import { render, staticRenderFns } from "./ClientColorManager.vue?vue&type=template&id=26d74e6c&scoped=true"
import script from "./ClientColorManager.vue?vue&type=script&lang=js"
export * from "./ClientColorManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d74e6c",
  null
  
)

export default component.exports